import { render, staticRenderFns } from "./TypeEstateItemStatusForm.vue?vue&type=template&id=2cc3148c&"
import script from "./TypeEstateItemStatusForm.vue?vue&type=script&lang=js&"
export * from "./TypeEstateItemStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports